export default "__VITE_ASSET__PuxGzEGc__"